import { render, staticRenderFns } from "./DeleteClientModal.vue?vue&type=template&id=a7e1ce96&scoped=true"
import script from "./DeleteClientModal.vue?vue&type=script&lang=js"
export * from "./DeleteClientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e1ce96",
  null
  
)

export default component.exports